import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import Headerpage from "src/shared/components/header";
import Footerpage from "src/shared/components/footer";
// import GoogleLogo from "src/assets/2702602.png";
import "src/features/home/pages/signUp-pages/style.css";
import GoogleSignUpForm from 'src/shared/components/GoogleSignupForm'
const SignUppage: React.FC = () => {

    useEffect(() => {
        document.body.classList.add("signUp");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Clear signup data when arriving at sign-up page
        sessionStorage.removeItem("newUserDetails");
        return () => {
          document.body.classList.remove("signUp");
        };
        
      
      }, []);

     

    return (<>


        <Headerpage/>
        <div className="container-inner">
            <div className=" content-leader"
                style={{
                    height:"calc(100vh - 153px)",
                    width: "100%",
                    backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/gritp.jpg')})`
                }}>
 
                <div className="welcome-back welcome-outer">
                    <div className="sign-In-back sign-back-outer">
                        <h1 className="sign-in-head">Let’s get started for free!</h1>
                        {/* <Link to="/name"><button className="sign-btn"><img src={GoogleLogo}/><span>Sign up with Google</span></button></Link> */}
                        <GoogleSignUpForm />
                    </div>
                </div>

            </div>

        </div>
      <Footerpage/>



    </>);
}
export default SignUppage;


// WEBPACK FOOTER //
// ./src/features/home/pages/signUp-pages/signup.tsx